<template>
  <div class="not-found-page">
    <a-result status="404" title="404" sub-title="页面不存在">
    </a-result>
  </div>
</template>

<style lang="less" scoped>
@import 'NotFound';
</style>

<script>
import NotFound from './NotFound'
export default NotFound
</script>
